import addError from '../../../utils/error.jsx';

export function request(id, sportId, data) {
    return {
        type: 'GRADES_UPDATE_REQUEST',
        sportId,
        data,
        id
    };
}

export function error(id, errors) {
    addError(errors);

    return {
        type: 'GRADES_UPDATE_ERROR',
        errors,
        id
    };
}

export function finish(id, data) {
    return {
        type: 'GRADES_UPDATE_FINISH',
        data,
        id
    };
}

export function update(id, data) {
    data.id = id;

    return bulk([ data ]);
}

export function bulk(data) {
    data.forEach(x => {
        x.id = parseInt(x.id, 10);
    });

    return {
        type: 'GRADES_DATA',
        data
    };
}
